import { toast } from "src/shadcn/ui/use-toast";
import { useCentralAPI } from "./centralAPI";
import { useProjectsAPI } from "./central.projectsAPI";

export function useOrganizationsAPI() {

    const {
        centralData,
        isFetching,
        isFetched,
        isError,
        error
    } = useCentralAPI({
        trigger:false
    });

    



    const listOrganizations = ()=>centralData?.Organizations||[]

    

    return {
        listOrganizations
    };
}